#define GLSLIFY 1
varying float vZ;

void main(){
    vec4 mvPosition =  modelViewMatrix * vec4( position, 1.0 );
    vZ = abs(position.z);
    gl_Position = projectionMatrix * mvPosition;
}